import { render, staticRenderFns } from "./DotIndicator.vue?vue&type=template&id=4ce0fd11&scoped=true"
import script from "./DotIndicator.vue?vue&type=script&lang=js"
export * from "./DotIndicator.vue?vue&type=script&lang=js"
import style0 from "./DotIndicator.vue?vue&type=style&index=0&id=4ce0fd11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce0fd11",
  null
  
)

export default component.exports